import { EmphasizeMatchingText } from 'components/shared/EmphasizeMatchingText/EmphasizeMatchingText';
import type { RateUnderlying } from 'models/underlying/rate';
import { FC, useContext } from 'react';

import { InputTextContext, StyledNameTD } from '../Common';

export const RateMenuOption: FC<RateUnderlying> = ({ name, currency }) => {
  const inputText = useContext(InputTextContext);

  return (
    <>
      <StyledNameTD>
        <span data-e2e={`multi-underlying-selector-option-name-${name}`}>
          <EmphasizeMatchingText searchText={inputText}>{name}</EmphasizeMatchingText>
        </span>
      </StyledNameTD>
      <td className="text-nowrap">
        <EmphasizeMatchingText searchText={inputText}>{currency}</EmphasizeMatchingText>
      </td>
    </>
  );
};
